module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_3016.ad1d2fad.png";